import { useEffect, useRef } from 'react';
import './container.css';

export function Container({ children, className }: { children?: React.ReactNode, className?: string }) {
  const containerRef = useRef<HTMLDivElement>(null);
  return (
    <div className={`panel ${className ?? ''}`} ref={containerRef}>
      <div className="dot">•</div>
      {children}
    </div>
  );
}

export default Container;